<template>
  <div class="goodslist-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item
        :to="{ path: `/goodslist?keyword=${keyword}&category=${item.id}` }"
        v-for="item in categoryPath"
        :key="item.id"
      >{{item.name}}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="chosedLabel">{{chosedLabel.name}}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="showLabel && categoryPath.length === 0">{{showLabel}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="flex" style="margin-top: 20px">
      <div class="select-box">
        <el-collapse :value="['1','2']">
          <!-- <div v-if="!query.labelID" class="label-list"> -->
          <div v-if="showCategory" class="label-list">
            <p
              @click="getLabel(item)"
              v-for="(item, i) in goodsTypeList"
              :key="i"
            >{{item.name}}（{{item.commodityNum}}）</p>
          </div>
          <div v-if="showCategoryLabel">
            <!-- <p class="title" @click="productTypeInit">
              <span>产品类型</span>
              <i class="el-icon-arrow-right"></i>
            </p> -->
            <el-collapse-item v-if="showCategoryLabel" title="产品类型" name="1">
              <el-checkbox-group v-model="query.labels" @change="getData">
               <div v-for="(item, i) in goodsTypeList2" :key="i">
                <el-checkbox :label="item.id">{{item.labelName}}（{{item.commodityNum}}）</el-checkbox>
               </div>
              </el-checkbox-group>
            </el-collapse-item>

          </div>
          <!-- 专区的复选框 -->
          <div v-if="specialGoodsTypeList.length > 0">
            <p class="title">
              <span>产品类型</span>
            </p>
            <!-- 专区单选 -->
            <!-- <el-radio-group v-model="query.categoryId" @change="getData">
              <div v-for="(item, i) in specialGoodsTypeList" :key="i">
                <el-radio
                  v-if="item"
                  @click.native.stop.prevent="cancelSel(item.id)"
                  :label="item.id"
                >{{item.name}}（{{item.commodityNum}}）</el-radio>
              </div>
            </el-radio-group> -->
            <el-checkbox-group v-model="query.categories" @change="getData">
              <div v-for="(item, i) in specialGoodsTypeList" :key="i">
                <el-checkbox :label="item.id">{{item.name}}（{{item.commodityNum}}）</el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
          <!-- 品牌的复选框 -->
          <div v-if="brandsGoodsTypeList.length > 0">
            <p class="title">
              <span>产品类型</span>
            </p>
            <el-checkbox-group v-model="query.categories" @change="getData">
              <div v-for="(item, i) in brandsGoodsTypeList" :key="i">
                <el-checkbox :label="item.id">{{item.name}}</el-checkbox>
              </div>
            </el-checkbox-group>
          </div>

          <!-- <el-collapse-item v-else title="产品类型" name="1">
          </el-collapse-item>-->
          <el-collapse-item title="价格" name="2">
            <el-checkbox-group v-model="query.priceSections" @change="getData">
              <div v-for="(item, i) in priceList" :key="i">
                <el-checkbox  :label="item.code">{{item.name}}</el-checkbox>
              </div>
            </el-checkbox-group>
            <!-- <el-input type="number" v-model="query.startPrice"></el-input>
            ——
            <el-input v-model="query.endPrice"></el-input>-->
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="list-box">
        <div v-if="categoryPath.length === 0" class="info">
          <el-divider>
            <b style="font-size: 32px;color:rgb(95,93,93)">{{showLabel}}</b>
          </el-divider>
        </div>
        <div v-else class="info">
          <el-divider>
            <b style="font-size: 32px;color:rgb(95,93,93)">{{categoryPath[categoryPath.length-1].name}}</b>
          </el-divider>
<!--          <p>{{categoryPath[categoryPath.length-1].remarks}}</p>-->
        </div>
        <!-- <div class="ad-img" v-if="$route.query.image" :style="`background-image: url(${$route.query.image})`"></div> -->
        <img
          @contextmenu.prevent
          style="width: 100%"
          v-if="$route.query.image"
          :src="$route.query.image"
        />
        <div class="search-box">
          <div>
            <span>排序</span>
            <el-select style="width: 160px;" v-model="query.sortWay">
              <el-option value="1" label="升序"></el-option>
              <el-option value="2" label="降序"></el-option>
            </el-select>
          </div>
          <div>
            <el-pagination
                background
              @size-change="pageSizeChange"
              @current-change="pageChange"
              :current-page.sync="query.pageNo"
              :page-sizes="[15, 30, 45, 60]"
              :page-size="query.pageSize"
              layout="sizes, prev, pager, next"
              :total="query.total"
            ></el-pagination>
          </div>
        </div>
        <div class="goods-list">
          <div v-for="(item,i) in goodsList" :key="i">
            <div class="img-box" @click="goDetail(item)">
             <div v-if="item.defaultImage" :style="{'background-image': `url(${item.defaultImage})`}" class="backImg"></div>
             <div class="backImg" v-else :style="{'background-image': `url(${noImg})`}"></div>
              <!-- <img @contextmenu.prevent :src="item.defaultImage" /> -->
            </div>
            <p class="name">{{item.name}}</p>
            <p class="price">
              价格：
              <span v-if="$store.state.user.username">￥{{item.marketPrice}}</span>
              <span v-else :style="{'font-size': '12px', 'color': '#999'}">登录后可见</span>
              <!-- <span
                v-if="item.collectivePrice && $store.state.user.info.username"
                class="collect-price"
                style="color: #ffa626;"
              >集采价：￥{{item.collectivePrice}}</span> -->
            </p>
            <!-- ￥{{$store.state.user.info.userType == 4 ? item.collectivePrice:item.preferentialPrice}} -->
            <div class="btns">
              <button class="common-btn common-btn-h1" @click="attention(item)">关注</button>
              <button class="common-btn btn-cart" @click="addCart(item)"><i class="iconfont icon-jiantou_liebiaoxiangyou_o"></i><span>加入购物车</span></button>
            </div>
          </div>
        </div>
        <div class="search-box">
          <div>
            <span>排序</span>
            <el-select style="width: 160px;" v-model="query.sortWay">
              <el-option value="1" label="升序"></el-option>
              <el-option value="2" label="降序"></el-option>
            </el-select>
          </div>
          <div>
            <el-pagination
                background
              @size-change="pageSizeChange"
              @current-change="pageChange"
              :current-page.sync="query.pageNo"
              :page-sizes="[15, 30, 45, 60]"
              :page-size="query.pageSize"
              layout="sizes, prev, pager, next"
              :total="query.total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  goodsList,
  commodityByAdvertising,
  categoryByBrand,
  commodityBySpecial,
  categoryBySpecial,
  cartAdd,
  getCommodityNum,
  categoryLabel,
  getCommoditySectionCount,
  groupsById,
  myAttentionAdd,
  commodityByRecomendId
} from "@/js/api";
import noImg from "../../assets/no-picture.png";
export default {
  name: "goodslist",
  data() {
    return {
      showLabel: this.$route.query.label || "",
      showCategoryLabel: false,
      showCategory: false,
      categoryPath: [],
      noImg,
      query: {
        sortWay: "",
        pageNo: 1,
        pageSize: 15,
        total: 0,
        labelID: null,
        goodsType: [],
        labels: [],
        categories: [],
        priceSections: [],
        categoryId: ""
        // startPrice: null,
        // endPrice: null
      },
      goodsTypeList: [],
      chosedLabel: null,
      goodsTypeList2: [],
      specialGoodsTypeList: [],
      brandsGoodsTypeList: [],
      priceList: [],
      goodsList: []
    };
  },
  computed: {
    keyword: function() {
      return this.$route.query.keyword || "";
    }
  },
  watch: {
    $route: function(old, to) {
      this.getCategoryPath();
      this.getCommodityNum();
      this.productTypeInit();
    },
    "$store.state.category.tree": function() {
      this.getCategoryPath();
    }
  },
  mounted() {
    this.getData();
    this.getCategoryPath();
    this.getCommodityNum();
  },
  methods: {
    productTypeInit() {
      this.query.labelID = null;
      this.chosedLabel = null;
      this.query.labels = [];
      this.goodsTypeList2 = [];
      this.specialGoodsTypeList = [];
      this.brandsGoodsTypeList = [];
      this.getData();
    },
    getCommodityNum() {
      const id = this.$route.query.category;
      const sdata = {
        id
      };
      if (id) {
        getCommodityNum(sdata).then(res => {
          if (res.code == 0) {
            this.goodsTypeList = res.result || [];
            //有分类显示分类，没有分类显示标签
            if(this.goodsTypeList.length > 0){
              this.showCategoryLabel = false;
              this.showCategory = true;
            }else{
              categoryLabel({
                id: id
              }).then(res => {
                if (res.code == 0) {
                  this.goodsTypeList2 = res.result || [];
                  if(this.goodsTypeList2.length > 0){
                    this.showCategory = false;
                    this.showCategoryLabel = true;
                  }
                }
             });
            }
          }
        });
      }
      const specialId = this.$route.query.specialId;
      const brandId = this.$route.query.brandId;
      // 通过专区过来
      if (specialId) {
        sdata.id = specialId;
        categoryBySpecial(sdata).then(res => {
          if (res.code == 0) {
            this.specialGoodsTypeList = res.result || [];
          }
        });
      } else if (brandId) {
        // 通过品牌过来
        sdata.id = brandId;
        categoryByBrand(sdata).then(res => {
          if (res.code == 0) {
            this.brandsGoodsTypeList = res.result || [];
          }
        });
      }
    },
    getCategoryPath() {
      const category = this.$route.query.category;
      if (!category) return;
      const tree = this.$store.state.category.tree;
      const data = this.searchData(tree, category);
      this.categoryPath = data;
    },
    searchData(treeList, val) {
      for (let i = 0; i < treeList.length; i++) {
        if (treeList[i].id == val) return [treeList[i]];
        else if (treeList[i].children) {
          const res = this.searchData(treeList[i].children, val);
          if (res.length > 0) return [treeList[i]].concat(res);
        }
      }
      return [];
    },
    pageChange: function(page) {
      this.query.pageNo = page;
      this.getData();
    },
    pageSizeChange: function(size) {
      this.query.pageSize = size;
      this.getData();
    },
    getLabel(item) {
      // 如果目前是一级，跳转到所选二级
      const category = this.$route.query.category;
      const isFirst = this.$store.state.category.tree.filter(
        z => z.value == category
      );
      if (isFirst.length > 0) {
        this.$router.push(`/goodslist?category=${item.id}`);
        return;
      }

      // 二级标签查询三级标签作为复选框
      this.query.labelID = item.id;
      this.chosedLabel = item;
      categoryLabel({
        id: item.id
      }).then(res => {
        if (res.code == 0) {
          this.goodsTypeList2 = res.result || [];
          if(this.goodsTypeList2.length > 0){
            this.showCategory = false;
            this.showCategoryLabel = true;
          }
        }
      });
      this.getData();
    },
    getGroupData(data) {
      this.query.total = data.length;
      this.goodsList = data;
    },
    cancelSel(e) {
      if (this.query.categoryId === e) {
        this.query.categoryId = null;
      } else this.query.categoryId = e;
      this.getData();
    },
    getData: function() {
      // 通过分组商品过来
      const groupId = this.$route.query.groupId;
      if (groupId) {
        return groupsById({ id: groupId }).then(res => {
          this.getGroupData(res.result || []);
          // const arr = res.result;
          // if (arr.length > 1) {
          //   this.$router.push(`goodsList?groupID=${item.id}`);
          // } else if (arr.length == 1) {
          //   const data = arr[0];
          //   this.$router.push(
          //     `goodsdetail?id=${data.id}&groupNo=${data.groupNo}`
          //   );
          // }
        });
      }
      // 普通查询
      const brandId = this.$route.query.brandId;
      const goodsType = this.query.goodsType;
      const sdata = {
        name: this.keyword || "",
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        priceSections: this.query.priceSections.map(z => ({
          code: z
        })),
        labels: this.query.labels.map(z => ({
          id: z
        }))
        // priceSections: [{
        //   startPrice: Number(this.query.startPrice),
        //   endPrice: 99999,
        // }]
      };
      if (sdata.priceSections.length === 0) {
        delete sdata.priceSections;
      }
      if (sdata.labels.length === 0) {
        delete sdata.labels;
      }
      // 二级标签查全部
      if (this.$route.query.category) {
        sdata.categories = [
          {
            id: this.$route.query.category
          }
        ];
      }
      if (goodsType.length > 0) {
        sdata.categories = goodsType.map(z => ({
          id: z
        }));
      }
      if (brandId) {
        sdata.brands = [
          {
            id: brandId
          }
        ];
      }
      // 选中三级标签时
      if (this.chosedLabel) {
        sdata.categories = [
          {
            id: this.chosedLabel.id
          }
        ];
      }
      // 品牌或专区选择的标签
      if (this.query.categories.length > 0) {
        sdata.categories = this.query.categories.map(z => ({
          id: z
        }));
      }

      const specialId = this.$route.query.specialId;
      const advertiseId = this.$route.query.advertiseId;
      const recommendId = this.$route.query.recommendId
      // 通过专区过来
      if (specialId) {
        sdata.id = specialId;
        // 专区单选
        // if (this.specialGoodsTypeList.length > 0 && this.query.categoryId) {
        //   sdata.categoryId = this.query.categoryId;
        // }
        commodityBySpecial(sdata).then(res => {
          if (res.code == 0) {
            this.query.total = res.result.total;
            this.goodsList = res.result.records || [];
          }
        });
      } else if (advertiseId) {
        // 通过主页广告过来
        sdata.id = advertiseId;
        commodityByAdvertising(sdata).then(res => {
          if (res.code == 0) {
            this.query.total = res.result.total;
            this.goodsList = res.result.records || [];
          }
        });
      }else if(recommendId){
        sdata.schemeId = recommendId;
        commodityByRecomendId(sdata).then(res=>{
          if (res.code == 0) {
            this.query.total = res.result.total;
            this.goodsList = res.result.records || [];
          }
        })
      }
       else {
        // 其他查询商品
        goodsList(sdata).then(res => {
          if (res.code == 0) {
            this.query.total = res.result.total;
            this.goodsList = res.result.records || [];
          }
        });
      }
      getCommoditySectionCount(sdata).then(res => {
        if (res.code == 0) {
          this.priceList = res.result || [];
        }
      });
    },
    goDetail: function(item) {
      if (item && item.id) {
        const query = this.$route.query;
        let search = location.href.split("goodslist?")[1];
        // const specialId = this.$route.query.specialId;
        // const brandId = this.$route.query.brandId;
        if (query.specialId) {
          search = `specialId=${query.specialId}&label=${query.label}`;
        } else if (query.brandId) {
          search = `brandId=${query.brandId}&label=${query.label}`;
        } else if (query.category) {
          search = `category=${query.category}`;
        }
        // this.$router.push(
        //   `goodsdetail?id=${item.id}&groupNo=${item.groupNo}&${search}`
        // );
        window.open(
          `/#/goodsdetail?id=${item.id}&groupNo=${item.groupNo}&${search}`
        );
      }
    },
    addCart: function(item) {
      if (!this.$store.state.user.info.id)
        return this.$message.error("请先登录！");
      cartAdd({
        commodityId: item.id,
        userId: this.$store.state.user.info.id
      }).then(res => {
        if (res.code == 1) {
          this.$message.success(res.message);
        } else if (res.code == 2) {
          // 不能单独购买
          this.$confirm('该商品需以整套方案购买, 查看其组合商品?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            groupsById({ id: item.id }).then(res => {
              const arr = res.result;
              if (arr.length > 1) {
                this.$router.push(`goodsList?groupId=${item.id}`);
              } else if (arr.length == 1) {
                const data = arr[0];
                this.$router.push(
                  `goodsdetail?id=${data.id}&groupNo=${data.groupNo}`
                );
              }else{
                return this.$message.warning("对不起！改商品未关联到组合商品，看看其他的把！");
              }
            });
          }).catch(() => {
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    attention(item) {
      if (!this.$store.state.user.info.id)
        return this.$message.error("请先登录！");
      myAttentionAdd({
        id: item.id
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>

<style scoped>
.info{height: 40px;}

.el-checkbox-group>>>.el-checkbox__input.is-checked + .el-checkbox__label {
    color: rgb(131,197,136);
  }
.el-checkbox-group>>>.el-checkbox__input.is-checked .el-checkbox__inner{background-color: rgb(131,197,136);border-color: rgb(131,197,136);}
.select-box >>> .el-radio-group {
  line-height: 1.5;
}
.search-box>>> .el-pager li{
  border: 1px solid #C0C4CC;
   margin-left: 5px;
   /* padding: 2px; */
}
.search-box>>>.btn-prev,.search-box>>>.btn-next{
  border: 1px solid #C0C4CC;
   margin-left: 5px;
}
</style>
<style lang="less" scoped>
@img-wid: 224px;
.goodslist-page {
  margin: 20px auto;
  width: 1060px;
  .flex {
    display: flex;
    align-items: flex-start;
  }
  .ad-img {
    margin: 12px 0;
    width: 100%;
    height: 400px;
    background-size: cover;
  }
  .select-box {
    width: 240px;
    .label-list {
      p {
        margin: 12px 0;
        border-bottom: dashed 1px #ccc;
        line-height: 32px;
        cursor: pointer;
      }
    }
    .title {
      margin-bottom: 12px;
      padding-right: 8px;
      line-height: 32px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      i {
        font-size: 13px;
        transform: rotate(90deg);
      }
    }
  }

  .list-box {
    margin-left: 80px;
    flex: 1;
    .info p {
      margin-top: 40px;
      text-align: center;
    }

    .search-box {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      > div {
        div ~ div {
          margin-left: 20px;
        }
        span {
          margin-right: 8px;
        }
      }
    }
    .goods-list {
      display: flex;
      flex-wrap: wrap;
      > div {
        margin: 10px;
        width: @img-wid;
      }
      .img-box {
        height: @img-wid;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background: #fff;
        .backImg{
           width: 100%;
          height: 100%;
          // background-size: contain;
          background-size: auto 100%;
          background-position: center;
          background-repeat: no-repeat;

        }
      }
      .name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      img {
        max-width: @img-wid;
        max-height: @img-wid;
      }
      p {
        margin-top: 20px;
        font-size: 13px;
      }
      p.price {
        color: rgb(197,88,47);
        margin-top: 8px;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
}
</style>
